import { render, staticRenderFns } from "./ErrorDisplay.vue?vue&type=template&id=4b83205c&scoped=true&"
import script from "./ErrorDisplay.vue?vue&type=script&lang=ts&"
export * from "./ErrorDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorDisplay.vue?vue&type=style&index=0&id=4b83205c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b83205c",
  null
  
)

export default component.exports